/**
 * SSO Auth Reducer
 *
 * Manages global SSO authentication state that needs to be accessed
 * by multiple components across the Staff Dashboard application.
 *
 * State:
 * - customerId: The customer ID for the current session
 * - isSsoEnabled: Whether SSO is enabled for this customer
 * - loading: Whether auth state is still loading
 */

import { SET_SSO_AUTH_STATE, SET_SSO_AUTH_CUSTOMER_ID } from "../actions/ActionTypes";

const initialState = {
  customerId: null,
  isSsoEnabled: false,
  loading: true,
};

const SsoAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SSO_AUTH_STATE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case SET_SSO_AUTH_CUSTOMER_ID: {
      return {
        ...state,
        customerId: action.customerId,
      };
    }
    default:
      return state;
  }
};

export default SsoAuthReducer;

